<ng-container *ngFor="let menu of menus; let i = index">
    <div class="panel" *ngIf="menu?.children?.length > 0">
        <div class="menu-category">
            <label nz-checkbox [(ngModel)]="menu.checked" [nzIndeterminate]="menu.indeterminate"
                   (ngModelChange)="categoryChecked(i)">{{ menu.category }}</label>
        </div>
        <div class="resource-box" nz-row>
            <div
                *ngFor="let child of menu.children;"
                class="tab"
                nz-col
                nzSpan="8"
            >
                <label
                    nz-checkbox
                    [(ngModel)]="child.checked"
                    (ngModelChange)="menuChecked(i)"
                >
                    {{ child.tab || child.label }}
                </label>
            </div>
        </div>
    </div>
</ng-container>
